<template>
  <div id="o2o-survey-tool">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: 'O2O Survey Tool'
    }
  },
  data() {
    return {
      
    }
  },
  async created() {
    
  },
  methods: {}
}
</script>
